if(document.querySelector('.single-product'))
{
        setInterval( () => {
        if(document.querySelector('.single-product__media').getBoundingClientRect().height < $('.single-product__article').offset().top )
    {
        $('.single-product__article').css('position','static');
    }
    else{
        $('.single-product__article').css('position','sticky')
        $('.single-product__article').css('top','60px')
        // var articleHeight = document.querySelector('.single-product__article-box').getBoundingClientRect().height
        // $('.single-product__article').css('height',articleHeight)
        $('.body-container-wrapper').css('overflow','visible')
    }    
    },200)
}
